module.exports = __webpack_public_path__ + "static/img/bonus_4.9260324.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dglfr/bonus_4.png
// module id = JtVl
// module chunks = 0